module.exports = __webpack_public_path__ + "static/media/SRPB77_03.322d89a7.jpg";